import { IconSize, useLayoutContext, useScaleFactor, useTheme, AHIcon } from "arkh";

import React from "react";
import { View } from "react-native";

export const EmptyResult = ({
  size,
  absoluteSize,
}: {
  size?: IconSize;
  absoluteSize?: number;
}) => {
  const theme = useTheme();
  const layout = useLayoutContext();
  const sf = useScaleFactor();
  const resolvedSize = absoluteSize ?? layout.icon[size ?? "medium"] * sf;

  return (
    <View style={{ width: resolvedSize }}>
      <AHIcon
        type="minus"
        forceSize={resolvedSize}
        customColor={theme.negative}
      />
    </View>
  );
};
